import PropTypes from 'prop-types';

const LockIcon = ({ className }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    className={className}
  >
    <rect className="lockBg" width="22" height="22" rx="11" />
    <path
      className="lockBody"
      d="M8.5 10.5V8.5C8.5 7.83696 8.76339 7.20107 9.23223 6.73223C9.70107 6.26339 10.337 6 11 6C11.663 6 12.2989 6.26339 12.7678 6.73223C13.2366 7.20107 13.5 7.83696 13.5 8.5V10.5M7.5 10.5H14.5C15.0523 10.5 15.5 10.9477 15.5 11.5V15C15.5 15.5523 15.0523 16 14.5 16H7.5C6.94772 16 6.5 15.5523 6.5 15V11.5C6.5 10.9477 6.94772 10.5 7.5 10.5Z"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

LockIcon.propTypes = {
  className: PropTypes.string
};

LockIcon.defaultProps = {
  className: ''
};

export default LockIcon;
